var React = require('react');

function CollapseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#666","strokeWidth":"1.5","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M7.664 10.446h10M2.263 5.919h15.401M7.664 1.391h10","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M4.091 2.907L1.263 5.736 4.09 8.564","key":1})]));
}

CollapseInline.defaultProps = {"width":"19","height":"12"};

module.exports = CollapseInline;

CollapseInline.default = CollapseInline;
